// 基础条件查询
const bass_addition_search_map = new Map([
  [0, "全部"],
  [1, "是"],
  [2, "否"],
  [3, "空"]
])

const bass_addition_search_list = Array.from(bass_addition_search_map, ([value, name]) => ({
  label: name,
  value,
}))


// 是否异地购车
export const isRemoteMap = new Map(
  Array.from(bass_addition_search_map).slice(0,4)
)
export const isRemoteList = bass_addition_search_list.slice(0,4)


// 是否Dcc线索
export const isDccClueMap = new Map([
  [1, "是"],
  [0, "否"],
])
export const isDccClueList = bass_addition_search_list.slice(0,3)

export const deviceTypeMap = new Map([
  ['Windows', 0],
  ['macOS', 5]
])

export const isWechatClueMap = new Map([
  [0, "全部"],
  [1, "是"],
  [2, "否"],
])